import { render, staticRenderFns } from "./exportList.vue?vue&type=template&id=a0af0c6a&scoped=true&"
import script from "./exportList.vue?vue&type=script&lang=js&"
export * from "./exportList.vue?vue&type=script&lang=js&"
import style0 from "./exportList.vue?vue&type=style&index=0&id=a0af0c6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0af0c6a",
  null
  
)

export default component.exports